<template>
  <a class="btn" :href="url">
    {{ text }}
  </a>
</template>

<script>
  export default {
    name: "tertiarybutton",

    props: ["text","url"]
  }
</script>

<style lang="scss" scoped>
.btn {
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid var(--black);
  border-radius: 3px;
  display: inline-block;
  transition: 0.3s;
  font-family: var(--roboto);
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 0.875;
  text-align: center;
  color: var(--black);
  text-decoration: none;
  padding: 6px 10px;
  cursor: pointer;
  margin: 0 5px;
}

.btn:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style>